export const SET_STATE = 'checkoutPage/promotionCode/SET_STATE';
export const SET_PROMOTION_CODE = 'checkoutPage/promotionCode/SET_PROMOTION_CODE';
export const REQUEST_PROMOTION_CODE_VALIDITY = 'checkoutPage/promotionCode/REQUEST_PROMOTION_CODE_VALIDITY';
export const SET_PROMOTION_CODE_VALIDITY = 'checkoutPage/promotionCode/SET_PROMOTION_CODE_VALIDITY';
export const RESET_PROMOTION_CODE = 'checkoutPage/promotionCode/RESET_PROMOTION_CODE';
